export enum TimelineVehicleStatesMessages {
  statesTitle = "timelineVehicleStates.statesTitle",
  manometer = "timelineVehicleStates.manometer",
  blockedVehicle = "timelineVehicleStates.blockedVehicle",
  blockingDate = "timelineVehicleStates.blockingDate",
  postUnloadIdleTime = "timelineVehicleStates.postUnloadIdleTime",
  effectiveUnloadTime = "timelineVehicleStates.effectiveUnloadTime",
  unloadBreakdownTitle = "timelineVehicleStates.unloadBreakdownTitle",
  unloadBreakdownHelp = "timelineVehicleStates.unloadBreakdownHelp"
}

export type TranslationTimelineVehicleStatesMessages = {
  [key in TimelineVehicleStatesMessages]: string;
}
